module.exports = __webpack_public_path__ + "img/logo.long.b45a1bff.png";